<template>
  <b-row>
    <b-col sm="12">
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading
            :module-id="access.module_id"
            :profile-id="access.profile_id"
            :reference="access.view_reference"
            summary-only
          />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions">
              <TabHeaderActions />
            </div>
            <div class="list-view-heading__controls-end">
              <b-button variant="link"
                        class="list-view-icon-btn"
                        :class="{ 'list-view-icon-btn--active': filtersOpen }"
                        v-b-tooltip.hover.bottom
                        :title="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'"
                        :aria-label="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'"
                        @click="filtersOpen = !filtersOpen">
                <AppIcon name="filter" :fill="filtersOpen" />
              </b-button>
            </div>
          </div>
        </section>

        <b-collapse v-model="filtersOpen">
          <div class="list-view-toolbar__filters">
            <div class="list-view-filter" style="flex: 1 1 230px; max-width: 340px;">
              <label class="filter-label">Proveedores</label>
              <v-select :options="arr.filters.suppliers" v-model="filters.suppliers" placeholder="Todos" :multiple="true" :select-on-tab="true"></v-select>
            </div>
            <b-button variant="outline-dark" size="sm" @click="filterImport()" v-b-tooltip.hover title="Aplicar filtros" style="height: 31px; width: 31px; padding: 0; flex-shrink: 0;">
              <AppIcon name="filter" />
            </b-button>
          </div>
        </b-collapse>
      </b-card>

      <b-card>
        <b-row>
          <b-col lg="6">
            <b-table class="app-table cost-import-log-table"
                    ref="table"
                    responsive
                    :stacked="isMobileViewport ? 'md' : false"
                    sticky-header="60vh"
                    :hover="true"
                    :small="true"
                    :fixed="false"
                    :items="table.items"
                    :fields="table.fields"
                    :current-page="table.currentPage"
                    :per-page="table.perPage"
                    :busy="table.isBusy"
                    v-if="table.items.length || table.isBusy">

                <template v-slot:table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Cargando...</strong>
                  </div>
                </template>

                <template v-slot:cell(date)="data">
                  {{ moment(data.item.created_at).format('DD MMMM YYYY') }}
                </template>

                <template v-slot:cell(supplier)="data">
                  {{ data.item.supplier.name }}
                </template>

                <template v-slot:cell(type_import)="data">
                  <b-badge :variant="typeImportVariant(data.item.type_import)">
                    {{ formatTypeImport(data.item.type_import) }}
                  </b-badge>
                </template>

                <template v-slot:cell(count)="data">
                  <div v-if="parseFloat(data.item.count_rows)>0">
                    <div v-if="parseFloat(data.item.count_rows)==1">
                      <i><b>{{ data.item.count_rows }}</b> Registro</i>
                    </div>
                    <div v-else>
                      <i><b>{{ data.item.count_rows }}</b> Registros</i>
                    </div>
                  </div>
                  <div v-else>
                    <i>Sin Registros</i>
                  </div>
                </template>

                <template v-slot:cell(f_action)="data">
                  <b-dropdown right
                              no-caret
                              size="sm"
                              variant="link"
                              boundary="window"
                              :toggle-class="isMobileViewport ? 'cost-import-log-action-toggle-labeled' : 'app-table-action-toggle'"
                              :class="{ 'pull-right': !isMobileViewport }">
                    <template #button-content>
                      <AppIcon name="more_vert" :label="isMobileViewport ? 'Opciones' : 'Acciones'" :class="{ 'mr-1': isMobileViewport }" />
                      <span v-if="isMobileViewport">Opciones</span>
                    </template>

                    <b-dropdown-item @click="openDetail(data.item)">
                      <AppIcon name="visibility" /> Ver detalle
                    </b-dropdown-item>
                    <b-dropdown-item @click="download(data.item)">
                      <AppIcon name="download" /> Descargar
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
            </b-table>
            <EmptyState v-else
                        icon="reports"
                        title="No se encontraron registros"
                        description="Ajustá el filtro de proveedores para ampliar la búsqueda." />

            <div class="app-table-footer" v-if="table.tablePaginate">
              <span class="list-view-toolbar__count">{{ table.tablePaginate.total }} registros</span>
            </div>
          </b-col>
          <b-col lg="6">
            <section class="cost-import-log-help-panel">
              <div class="cost-import-log-help-panel__header">
                <span class="cost-import-log-help-panel__icon"><AppIcon name="help" /></span>
                <div>
                  <h6>Importaciones por proveedor</h6>
                  <p>Historial de listas de precios importadas.</p>
                </div>
              </div>

              <p>Mostramos todas las <b>importaciones</b> realizadas por cada proveedor.</p>

              <div class="cost-import-log-help-panel__block">
                <h6>Descargar una importación</h6>
                <p>Desde la opción <b>Descargar</b>, el sistema genera nuevamente el archivo <b>CSV</b> con los datos importados.</p>
              </div>
            </section>
          </b-col>
        </b-row>
      </b-card>

      <b-card body-class="py-2">
        <div class="list-view-footer">
          <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
            <AppIcon name="back" class="mr-1" />Volver
          </b-button>

          <nav v-if="table.tablePaginate">
            <b-pagination class="mb-0"
                          size="sm"
                          pills=""
                          :total-rows="table.tablePaginate.total"
                          :per-page="table.tablePaginate.per_page"
                          v-model="table.currentPage"
                          @input="filterImport()" />
          </nav>
        </div>
      </b-card>
    </b-col>

    <b-modal v-model="modal.detail.active"
             size="xl"
             scrollable>
      <div slot="modal-header" class="app-modal-header">
        <span class="app-modal-header__icon"><AppIcon name="visibility" /></span>
        <h5 class="app-modal-header__title">{{ modal.detail.title }}</h5>
      </div>

      <div class="app-modal-detail-list mb-3">
        <div class="app-modal-detail-list__row">
          <span class="app-modal-detail-list__label">Proveedor</span>
          <span class="app-modal-detail-list__value">{{ detail.import && detail.import.supplier ? detail.import.supplier.name : '-' }}</span>
        </div>
        <div class="app-modal-detail-list__row">
          <span class="app-modal-detail-list__label">Tipo</span>
          <span class="app-modal-detail-list__value">{{ detail.import ? formatTypeImport(detail.import.type_import) : '-' }}</span>
        </div>
        <div class="app-modal-detail-list__row">
          <span class="app-modal-detail-list__label">Fecha</span>
          <span class="app-modal-detail-list__value">{{ detail.import ? moment(detail.import.created_at).format('DD MMMM YYYY') : '-' }}</span>
        </div>
      </div>

      <b-table class="mb-0 app-table app-table--compact"
               ref="detailTable"
               responsive
               :stacked="isMobileViewport ? 'md' : false"
               :hover="true"
               :small="true"
               :fixed="false"
               :items="detail.items"
               :fields="detail.fields"
               :busy="detail.isBusy"
               v-if="detail.items.length || detail.isBusy">

        <template v-slot:table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Cargando...</strong>
          </div>
        </template>
      </b-table>
      <EmptyState v-else icon="reports" title="No se encontraron registros" />

      <div slot="modal-footer">
        <b-button variant="outline-secondary" size="sm" @click="modal.detail.active=false">
          <AppIcon name="x" class="mr-1" />Cerrar
        </b-button>
      </div>
    </b-modal>
  </b-row>
</template>

<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import moment from 'moment'
  import Funciones from '@/handler/funciones'
  import StorageLocal from '@/handler/storageLocal'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'

  export default {
    components: {
      TabHeaderActions,
    },

    data: () => {
      return {
        access: {
          module_id: Modules.COSTOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'crudImportLog',
        },
        table : {
          items: [],
          fields: [],
          currentPage: 1,
          perPage: 0,
          isBusy: false,
          tablePaginate: null,
        },
        arr: {
          filters : {
            suppliers: [],
          },
          export: [],
        },
        filters: {
          suppliers: null,
        },
        filtersOpen: false,
        isMobileViewport: false,
        modal: {
          detail: {
            active: false,
            title: 'Detalle de importación'
          }
        },
        detail: {
          import: null,
          items: [],
          fields: [
            {key: 'code', label: 'Código', class: "align-middle"},
            {key: 'action', label: 'Acción', class: "align-middle"},
            {key: 'observations', label: 'Observaciones', class: "align-middle"},
          ],
          isBusy: false,
        }
      }
    },

    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },

    mounted() {
      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)

      this.filtersOpen = StorageLocal.getValue('filters_open_crud_import_log') == 'true'

      this.loadFieldTable()
      this.filterLoad()
      this.filterImport()

      this.onWindowFocus = () => {
        if(document.hidden) return
        this.filterImport()
      }
      window.addEventListener('focus', this.onWindowFocus)
      document.addEventListener('visibilitychange', this.onWindowFocus)
    },
    activated() {
      this.filterImport()
    },
    beforeDestroy() {
      if(this.mobileMql) {
        this.mobileMql.removeEventListener('change', this.updateMobileViewport)
      }
      if(this.onWindowFocus) {
        window.removeEventListener('focus', this.onWindowFocus)
        document.removeEventListener('visibilitychange', this.onWindowFocus)
      }
    },
    watch: {
      filtersOpen(value) {
        StorageLocal.setValue('filters_open_crud_import_log', value ? 'true' : 'false')
      },
      isMobileViewport() {
        this.loadFieldTable()
      }
    },
    methods: {
      updateMobileViewport(e) {
        this.isMobileViewport = e.matches
      },

      alignClass(desktopClass) {
        return this.isMobileViewport ? 'text-left' : desktopClass
      },

      loadFieldTable() {
        this.table.fields = []
        this.table.fields.push({key: 'date', label: 'Fecha', class: "align-middle " + this.alignClass('text-left')})
        this.table.fields.push({key: 'supplier', label: 'Proveedor', class: "align-middle " + this.alignClass('text-left')})
        this.table.fields.push({key: 'type_import', label: 'Tipo', class: "align-middle " + this.alignClass('text-left')})
        this.table.fields.push({key: 'count', label: 'Registros', class: "align-middle " + this.alignClass('text-left')})
        this.table.fields.push({key: 'f_action', label: this.isMobileViewport ? 'Acción' : '', class: "align-middle " + this.alignClass('text-right')})
      },

      confirmDialog(message, options) {
        var danger = !!options.danger
        var icon = options.icon || (danger ? 'warning' : 'help')
        var title = this.$createElement('span', { class: 'app-confirm-header__title' }, [
          this.$createElement('AppIcon', { props: { name: icon } }),
          options.title
        ])
        return this.$bvModal.msgBoxConfirm(message, {
          title: title,
          size: 'sm',
          buttonSize: 'sm',
          okVariant: danger ? 'danger' : 'dark',
          okTitle: options.okTitle,
          cancelTitle: options.cancelTitle || 'Cancelar',
          footerClass: 'p-2',
          headerClass: danger ? 'app-confirm-header app-confirm-header--danger' : 'app-confirm-header',
          hideHeaderClose: false,
          centered: true
        })
      },

      // FILTER
      filterLoad() {
        this.filterLoadSuppliers()
      },
      filterLoadSuppliers() {
        var result = serviceAPI.obtenerProveedoresOnlyImport()
        result.then((response) => {
          var data = response.data

          this.arr.filters.suppliers = []
          data.forEach(element => {
            if(element.active && !element.shipping) {
              this.arr.filters.suppliers.push({ code: element.id, label: element.name })
            }
          });
        })
      },

      // DATA
      filterImport() {
        this.table.isBusy = true

        var result = serviceAPI.obtenerImportListCost(this.filters, this.table.currentPage)
        result.then((response) => {
          var data = response.data
          this.table.tablePaginate = data

          this.table.items = data.data

          this.table.isBusy = false
        })
        .catch(error => {
          this.table.isBusy = false
          this.$awn.alert(Error.showError(error))
        });
      },
      openDetail(item) {
        this.modal.detail.active = true
        this.detail.import = item
        this.detail.items = []
        this.detail.isBusy = true

        var result = serviceAPI.obtenerImportDetailListCost({
          import_id: item.id,
        })
        result.then((response) => {
          var arrData = response.data || []

          this.detail.items = arrData.map((element) => {
            let parsed = {}
            try {
              parsed = JSON.parse(element.content)
            } catch (e) {
              parsed = {}
            }

            return {
              code: parsed.code || '-',
              action: this.formatAction(element.action),
              observations: element.observations || '',
            }
          })

          this.detail.isBusy = false
        })
        .catch(error => {
          this.detail.isBusy = false
          this.$awn.alert(Error.showError(error))
        })
      },
      formatTypeImport(value) {
        if(!value) return 'default'
        return value
      },
      typeImportVariant(value) {
        if(value === 'delete') return 'danger'
        if(value === 'warning') return 'warning'
        return 'primary'
      },
      formatAction(value) {
        if(value === 'created') return 'Creado'
        if(value === 'updated') return 'Actualizado'
        return value || '-'
      },
      download(item) {
        this.confirmDialog('¿Descargar lista de precios?', {
          title: 'Descargar Lista de Precios',
          icon: 'download',
          okTitle: 'DESCARGAR',
        })
        .then(value => {
          if (value) {
            this.$awn.info("Estamos procesando el archivo, por favor espere...");
            let loader = this.$loading.show();

            this.arr.export = []

            var result = serviceAPI.obtenerImportDetailListCost({
              import_id: item.id,
            })
            result.then((response) => {
              var arrData = response.data

              if(arrData.length) {
                arrData.forEach(element => {
                  var item = JSON.parse(element.content)

                  this.arr.export.push(item)
                });

                loader.hide()
                this.$awn.success("Finalizamos el proceso, descargando archivo...");
                Funciones.exportToCSV(this.arr.export, 'list-cost-products')
              } else {
                loader.hide()
                this.$awn.success("Finalizamos el proceso. No se encontraron registros");
              }
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error))
        });
      }
    }
  }
</script>

<style scoped>
  .cost-import-log-help-panel {
    background: var(--app-color-surface-subtle);
    border: 1px solid var(--app-color-border);
    border-radius: 8px;
    color: var(--app-color-text-secondary);
    font-size: var(--app-text-sm);
    padding: 14px;
  }
  .cost-import-log-help-panel p {
    margin-bottom: 10px;
  }
  .cost-import-log-help-panel__header {
    align-items: center;
    display: flex;
    gap: 10px;
    margin-bottom: 12px;
  }
  .cost-import-log-help-panel__header h6 {
    color: var(--app-color-text);
    font-size: var(--app-text-sm);
    font-weight: 700;
    margin: 0;
  }
  .cost-import-log-help-panel__header p {
    color: var(--app-color-text-muted);
    font-size: var(--app-text-xs);
    margin: 1px 0 0;
  }
  .cost-import-log-help-panel__icon {
    align-items: center;
    background: var(--app-color-primary-soft);
    border: 1px solid var(--app-color-primary-200);
    border-radius: 8px;
    color: var(--app-color-primary);
    display: inline-flex;
    flex: 0 0 34px;
    height: 34px;
    justify-content: center;
    width: 34px;
  }
  .cost-import-log-help-panel__block {
    border-top: 1px solid var(--app-color-border);
    margin-top: 12px;
    padding-top: 12px;
  }
  .cost-import-log-help-panel__block h6 {
    color: var(--app-color-text);
    font-size: var(--app-text-xs);
    font-weight: 700;
    margin-bottom: 6px;
    text-transform: uppercase;
  }
  .cost-import-log-help-panel__block p {
    margin-bottom: 0;
  }
  @media (max-width: 767.98px) {
    .cost-import-log-help-panel {
      margin-top: 12px;
    }
  }
</style>

<style>
  /* Kebab con texto "Opciones" visible en mobile (ABM sin drawer: la única
     forma de llegar a Ver detalle/Descargar es esta acción, no puede quedar
     muda ni oculta). Alineado a la izquierda, como el resto del valor apilado. */
  .btn.cost-import-log-action-toggle-labeled {
    display: inline-flex !important;
    align-items: center;
    justify-content: flex-start;
    width: auto !important;
    height: auto !important;
    min-height: 0;
    padding: 0 !important;
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
    color: var(--app-color-text-secondary) !important;
    font-size: 13px;
    line-height: 1.15;
    white-space: nowrap;
  }
  .btn.cost-import-log-action-toggle-labeled:hover,
  .btn.cost-import-log-action-toggle-labeled:focus {
    color: var(--app-color-primary) !important;
    text-decoration: underline;
  }
  @media (max-width: 767.98px) {
    .cost-import-log-table.app-table.b-table-stacked-md > tbody > tr > td:last-child::before {
      content: attr(data-label) !important;
    }
  }
</style>
